import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqList } from "@/mocks/anime";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqList[0].id);

  const toggle = (id: string) => {
    setOpenId((current) => (current === id ? null : id));
  };

  return (
    <section id="faq" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <SectionHeading
        eyebrow="使用答疑"
        icon="ri-question-line"
        title="常见问题 · 关于本站与选番的那些疑问"
        description="整理了浏览本站时最常被问到的几个问题，点击任意一条即可展开答案，再次点击收起。"
      />

      <div className="max-w-4xl rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
        {faqList.map((item, index) => {
          const isOpen = openId === item.id;
          return (
            <div key={item.id} className={index !== faqList.length - 1 ? "border-b border-background-200/60" : ""}>
              <button
                type="button"
                onClick={() => toggle(item.id)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-4 hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <span className="flex items-center gap-3">
                  <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-sm font-bold">
                    <i className="ri-question-line" aria-hidden="true"></i>
                  </span>
                  <span className="font-medium text-sm md:text-base text-foreground-950">
                    {item.question}
                  </span>
                </span>
                <i
                  className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform duration-300 ${
                    isOpen ? "rotate-180" : ""
                  }`}
                  aria-hidden="true"
                ></i>
              </button>
              <div
                className={`grid transition-all duration-300 ease-in-out ${
                  isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-5 md:px-6 pb-5 pl-[3.75rem] text-sm leading-relaxed text-foreground-600">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}